var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 94,
    viewBox: "0 0 68 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2098 80.3102C43.2098 80.3102 43.8994 64.9096 43.9757 63.5304C44.052 62.1512 43.8222 60.0825 43.9757 58.7033C44.1293 57.3242 44.7738 56.0985 43.9923 53.6464C43.2098 51.1942 41.6771 49.0492 42.0605 41.5401C42.0605 41.5401 42.5203 38.0922 42.6738 37.4789C42.8274 36.8656 43.0048 33.4177 44.372 32.3456C45.7383 31.2726 47.5009 30.2006 48.344 29.8935C49.1871 29.5873 49.417 28.8977 49.417 28.8977C49.417 28.8977 50.1829 23.2275 52.7886 22.5379C52.7886 22.5379 54.781 22.2318 55.3934 22.5379C56.0067 22.8441 56.3891 23.7636 56.3891 27.4413C56.3891 27.4413 56.4655 31.0428 57.5384 32.422C58.6114 33.8011 58.3043 35.3044 58.3043 36.4684",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3736 81.0001C60.3736 81.0001 59.7604 73.4147 59.7604 69.8904C59.7604 66.3662 60.2964 60.9259 60.3736 59.623C60.4499 58.3202 60.3736 57.478 60.3736 57.478C60.3736 57.478 60.3736 55.7926 60.8333 55.1794C61.2931 54.5661 63.0556 53.2642 64.4348 47.9001C65.814 42.5361 66.9633 42.3071 66.887 40.5446C66.8107 38.782 64.8945 36.5606 64.4348 35.4876C63.9751 34.4146 63.326 32.1933 63.326 32.1933C63.326 32.1933 62.3661 29.7411 61.6765 28.7454C60.9869 27.7496 60.4509 25.987 60.3736 23.9946C60.2964 22.0022 58.6221 21.1866 57.4617 23.0751C56.3023 24.9637 56.3593 26.843 56.3888 27.4425",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1612 38.3865C66.1612 38.3865 66.9694 31.8097 66.8894 29.205C66.8094 26.6002 67.4217 23.1651 67.4217 22.0094C67.4217 20.8537 67.4282 8.67103 66.1612 6.44873C64.8942 4.22644 62.3648 5.52929 62.3648 7.52172C62.3648 9.51416 62.0586 15.1834 61.9814 16.41C61.9051 17.6356 61.0335 22.893 61.2394 27.9646",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1968 24.1167C56.1968 24.1167 57.3847 17.9408 57.997 16.409C58.6103 14.8763 60.0658 10.4327 60.2957 9.43691C60.5255 8.44115 61.5985 5.60559 61.981 4.22642C62.3635 2.84726 62.5943 0.854824 64.9692 1.00837C67.3441 1.16192 66.1599 6.44872 66.1599 6.44872",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1727 29.741C50.1727 29.741 51.6383 29.8945 52.1753 31.886C52.7113 33.8785 53.3246 35.4581 53.7843 36.4685C54.244 37.479 54.1677 39.6241 55.0099 41.5402C55.8531 43.4554 52.7876 44.6819 51.4085 42.1535C50.0293 39.625 50.1829 39.7528 49.7994 38.3865C49.416 37.0202 48.1141 36.2543 47.5771 34.7979",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8188 37.5561C44.8188 37.5561 48.2668 37.808 49.1485 37.146",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3649 26.4468C51.3649 26.4468 51.0247 29.5113 52.174 31.8871",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2095 38.3865C54.2095 38.3865 54.397 40.3918 55.699 40.3146C57.0018 40.2383 57.3843 39.2931 57.4615 38.3865C57.5379 37.4799 58.0895 34.1561 56.9329 31.144",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.293 70.5898H20.625V81H14.7656V52.5625H25.332C28.6914 52.5625 31.2826 53.3112 33.1055 54.8086C34.9284 56.306 35.8398 58.4219 35.8398 61.1562C35.8398 63.0964 35.4167 64.7174 34.5703 66.0195C33.737 67.3086 32.4674 68.3372 30.7617 69.1055L36.9141 80.7266V81H30.625L25.293 70.5898ZM20.625 65.8438H25.3516C26.8229 65.8438 27.9622 65.4727 28.7695 64.7305C29.5768 63.9753 29.9805 62.9401 29.9805 61.625C29.9805 60.2839 29.5964 59.2292 28.8281 58.4609C28.0729 57.6927 26.9076 57.3086 25.332 57.3086H20.625V65.8438Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 69.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhand);
export default __webpack_public_path__ + "static/media/Rhand.7a119d8a6206405b468220a663314076.svg";
export { ForwardRef as ReactComponent };